import gql from 'graphql-tag';

export const NAME =
  'compositions_CustomersWidget_caseCustomerServicePreferencesQuery';

const query = gql`
  query ${NAME} ($caseNumber: String!) {
    case (caseNumber: $caseNumber) {
      id
      customer(useCachedDataForCase: true) {
        ... on Customer {
          id
          servicePreferences {
            driverAuthorized
            ersComments
            tireDisposition
          }
        }

        ... on StoreCustomer {
          id
          servicePreferences {
            driverAuthorized
            ersComments
            tireDisposition
          }
        }
      }
    }
  }
`;

export default query;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/CustomerDetails/ServicePreferences/caseCustomerServicePreferencesQuery.js